export default class ConversationUserPermissionsModel {
  viewWhatsApp!: boolean;

  manageWhatsApp!: boolean;

  masterCrmUser!: boolean;

  allowToSaveAllAsMistake!: boolean;
}
